export default __webpack_public_path__ + "static/char-thumb-03-bb3934dbcb46c03b27f44a84e19b604b.png";